import React from 'react';
import SubPage from '#/common/components/SubPage';
import { useParams, useSearchParams } from 'react-router-dom';
import TemplatePicker from '../components/TemplatePicker';

const NewMaintenancePlanPage: React.FC = () => {
  const { id: assetId } = useParams();

  return (
    <SubPage type="form" title="Generate Maintenance Plan" showGoBackButton>
      <TemplatePicker assetId={assetId} />
    </SubPage>
  );
};

export default React.memo(NewMaintenancePlanPage);
